import React from 'react';
import showAlert from '../../../common/utils/alert';
import { getLanguageNameFromCode } from '../../../common/utils/languages';

export const ActiveLanguagesTable = ({
  projectId,
  localization,
  deleteLocalizationConfig,
  changeDefaultLanguage,
}) => {
  const isActiveLanguages = localization && localization.length > 0;
  if (!isActiveLanguages) return <div className="alert">No Active Language</div>;

  const handleDelete = (uuid) => {
    const preConfirm = () => deleteLocalizationConfig({ uuid, projectId });
    showAlert("You won't be able to revert it!", preConfirm, 'Yes, delete it!');
  };

  const handleSetDefault = (uuid) => {
    const preConfirm = () => changeDefaultLanguage({ uuid, projectId });
    showAlert('Do want to change the Default Language ?', preConfirm, 'Yes, Change it!');
  };

  return (
    <div className="table-responsive text-left">
      <table className="table table-bordered table-word-break">
        <thead>
          <tr>
            <th>Language</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {localization.map(({ uuid, language, isDefault }) => (
            <tr key={language}>
              <td>{getLanguageNameFromCode(language)}</td>
              <td>
                <button
                  type="button"
                  className="btn  btn-xs"
                  title="Set Default"
                  disabled={isDefault}
                  onClick={() => handleSetDefault(uuid)}
                >
                  <i className="wb webconnect-edit" /> Set Default
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-theme-delete btn-xs"
                  title="Delete Item"
                  disabled={isDefault}
                  onClick={() => handleDelete(uuid)}
                >
                  <i className="wb webconnect-trash-regular" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
